import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class EventPresenter extends EntityPresenter {
  static urn = 'events'

  static buffer() {
    return this.get(`buffer/uplinks`)
  }

  static navOptions() {
    return {
      icon: 'device_hub',
    }
  }
}

bindPresenterMethods(EventPresenter)
